export default __webpack_public_path__ + "media/design-system/icon/assets/brand/SM/check-de39dbb39b8b0ad921e67fec7221ae8e.svg";